import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import routes from '../../libs/routes';
import images from "../../libs/images";
import * as API from "../../libs/service";
import { useDispatch, useSelector } from 'react-redux';
import { loadingStart, loadingEnd } from "../../redux/loadingSlice";
import { open, close } from "../../redux/popupSlice";
import Popup01 from "../popup/Popup01";
import { ToastContainer, toast, Slide, Flip, Bounce } from 'react-toastify';
import { BrowserView, MobileView, isBrowser, isMobile, isChrome, isSafari, isIOS, isAndroid } from 'react-device-detect';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/autoplay';
import 'react-toastify/dist/ReactToastify.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import HLSVideo from '../../libs/hlsVideo';

// ==================== 상수 정의 ====================

// 헤더 텍스트
const HEADER_TEXT = {
  title: {
    ko: '폴리곤 모델링',
    en: 'Polygon Modeling'
  },
  subTitle: {
    ko: '유니티 엔진 내에서 로우 폴리부터 하이 폴리 메쉬까지 작업할 수 있습니다.',
    en: 'Work seamlessly within Unity to create everything from low-poly to high-poly meshes.'
  }
};

const CONTENT_ITEMS = [
  {
    title: { ko: '다양한 폴리곤 에디팅 툴', en: 'Versatile Polygon Editing Tools' },
    description: {
      ko: '정점, 선분, 면을 직접 조작하여 원하는 형태로 정밀하게 수정할 수 있습니다. 절단, 분할, 브릿지, 병합 등의 기능을 활용해 복잡한 구조도 쉽게 조정할 수 있으며, 직관적인 조작 방식으로 빠르게 모델을 편집할 수 있습니다.',
      en: 'Manipulate vertices, edges, and faces with precision to shape your models exactly as you envision. Easily adjust complex structures using tools like cut, split, bridge, and merge, enabling fast and intuitive model editing.'
    },
    video: "/m3u8/po_01.m3u8",
    thum: require("../../assets/thumnails/po_01_thum.webp"),
    reverse: false
  },
  {
    title: { ko: 'Bevel 툴을 이용한 곡면 생성', en: 'Smooth Curves with Bevel Tool' },
    description: {
      ko: '엣지와 면을 부드럽게 둥글게 만들거나 원하는 곡률을 적용하여 자연스러운 형태를 만들 수 있습니다. 캐릭터 모델링이나 건축, 제품 디자인에서 유용하며, 복잡한 설정 없이도 손쉽게 곡면을 조정할 수 있습니다.',
      en: 'Soften edges and faces or apply custom curvature to create natural shapes. Ideal for character modeling, architecture, and product design, the bevel tool lets you adjust curves effortlessly without complex settings.'
    },
    video: "/m3u8/po_02.m3u8",
    thum: require("../../assets/thumnails/po_02_thum.webp"),
    reverse: true
  },
  {
    title: { ko: 'Follow 툴과 Array 툴을 이용한 Path 기반 모델링', en: (<>{'Path-Based Modeling'}<br />{'with Follow & Array Tools'}</>) },
    description: {
      ko: 'Follow 툴을 사용하면 경로를 따라 3D 모델을 자동으로 생성할 수 있으며, Array 툴을 활용하면 일정한 간격으로 반복 배치하여 균일한 패턴을 손쉽게 만들 수 있습니다. 곡선 기반 모델링과 규칙적인 구조물 제작이 한층 간편해집니다.',
      en: 'Follow tool lets you automatically generate 3D models along a path.  With the Array tool, effortlessly create uniform patterns  by repeating objects at fixed intervals.  Path-based modeling makes structured designs easier than ever.'
    },
    video: "/m3u8/po_03.m3u8",
    thum: require("../../assets/thumnails/po_03_thum.webp"),
    reverse: false
  },
  {
    title: { ko: '스택 기반 모디파이어', en: 'Stack-Based Modifiers' },
    description: {
      ko: '미러, 서브디비전, FFT 등 스택 기반 모디파이어를 활용하면 모델을 빠르고 유연하게 수정할 수 있습니다. 비파괴적인 방식으로 원본을 유지하면서 효율적인 반복 편집, 대칭 모델링, 부드러운 형태 변형이 가능합니다.',
      en: 'Modify models quickly and flexibly using stack-based modifiers  like Mirror, Subdivision, and FFT. Work non-destructively to preserve  the original structure while making adjustments, ensuring efficient iterative edits, symmetrical modeling, and smooth shape transformations.'
    },
    video: "/m3u8/po_04.m3u8",
    thum: require("../../assets/thumnails/po_04_thum.webp"),
    reverse: true
  },
  {
    title: { ko: '디폼 브러시를 통한 유기적인 형태 조작', en: 'Intuitive Shape Refinement' },
    description: {
      ko: '브러시를 사용해 표면을 부드럽게 다듬거나 볼륨을 추가해서  자연스러운 형태를 만들 수 있으며, 캐릭터 모델링, 지형 제작 등 다양한 분야에서 활용할 수 있습니다.',
      en: 'Use brushes to smooth surfaces or add volume for  natural-looking shapes. Ideal for character modeling,  terrain creation, and various design applications.'
    },
    video: "/m3u8/po_05.m3u8",
    thum: require("../../assets/thumnails/po_05_thum.webp"),
    reverse: false
  }
];

// 배너 텍스트
const BANNER_TEXT = {
  title: {
    ko: '3D 모델링의 정석',
    en: 'Fine-Tune Every Polygon'
  },
  inquiryButton: {
    ko: '문의 하기',
    en: 'Contact Us'
  },
  startButton: {
    ko: '무료로 써보기',
    en: 'Try for Free'
  }
};

// ==================== 컴포넌트 ====================
export default function PModeling() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const lang = useSelector(state => state.langReducer.lang);
  const [supBtnHover, setSupBtnHover] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="main_back">
        <div className="main_part padding">
          {/* 헤더 섹션 */}
          <div className="header_page_title_box">
            <p className="title">
              {lang === 0 ? HEADER_TEXT.title.ko : HEADER_TEXT.title.en}
            </p>
            <span className="sub_title">
              {lang === 0 ? HEADER_TEXT.subTitle.ko : HEADER_TEXT.subTitle.en}
            </span>
          </div>

          {/* 콘텐츠 섹션 */}
          <div className="header_page_content_box">
            {CONTENT_ITEMS.map((item, index) => {
              return (
                <div className={`content ${item.reverse ? 'end' : ''}`} key={index}>
                  {item.reverse ? (
                    <>
                      <div className="title_box">
                        <p>{lang === 0 ? item.title.ko : item.title.en}</p>
                        <span style={{ whiteSpace: 'pre-line' }}>
                          {lang === 0 ? item.description.ko : item.description.en}
                        </span>
                      </div>
                      <div className="img_box">
                        <HLSVideo
                            width="100%"
                            height="100%"
                            autoPlay
                            muted
                            loop
                            playsInline
                            poster={item.thum}
                            src={item.video}
                        >
                            소개 영상입니다.
                        </HLSVideo>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="img_box">
                        <HLSVideo
                            width="100%"
                            height="100%"
                            autoPlay
                            muted
                            loop
                            playsInline
                            poster={item.thum}
                            src={item.video}
                        >
                            소개 영상입니다.
                        </HLSVideo>
                      </div>
                      <div className="title_box">
                        <p>{lang === 0 ? item.title.ko : item.title.en}</p>
                        <span style={{ whiteSpace: 'pre-line' }}>
                          {lang === 0 ? item.description.ko : item.description.en}
                        </span>
                      </div>
                    </>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* 배너 섹션 */}
        <div className="page_start_banner">
          <div className="content">
            <p className="title">
              {lang === 0 ? BANNER_TEXT.title.ko : BANNER_TEXT.title.en}
            </p>
            <div className="btn_box">
              <button 
                type="button" 
                className={`start ${lang === 1 ? 'eng' : ''}`}
                style={{width: 220,}}
                onClick={() => {
                  navigate(routes.Price);
              }}
              >
                {lang === 0 ? BANNER_TEXT.startButton.ko : BANNER_TEXT.startButton.en}
              </button>              
              <button 
                type="button" 
                className={`inquiry ${lang === 1 ? 'eng' : ''}`}
                style={{width: 220,}}
                onClick={() => navigate(routes.Inquiry)}
              >
                {lang === 0 ? BANNER_TEXT.inquiryButton.ko : BANNER_TEXT.inquiryButton.en}
              </button>

            </div>
          </div>
        </div>
      </div>

      <ToastContainer 
        position="bottom-center"
        transition={Slide}
        limit={1}
        closeButton={false}
        autoClose={1000}
        style={{ width: isBrowser ? 400 : '100%', marginBottom: isBrowser ? 60 : 70 }}
        hideProgressBar
      />
    </>
  );
}